import { Component, Vue } from 'vue-property-decorator';
import VuePaginate from "@/views/VuePaginate.vue";
import AsyncPageLoader from "@/views/AsyncPageLoader.vue";

@Component({ components: { AsyncPageLoader, VuePaginate } })
export default class ScrollPaginationMixin extends Vue {

  
  public asyncPageLoader = false
  public counter = 0;
  public searchString = null;
  public paginationConfig = {
    currentPage: 1,
    totalPages: 0,
    pageLimit: 10,
    totalLength: 0
  };


}